"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosStoreCreditRedeemInputSchema = exports.APosStoreCreditAdjustInputSchema = exports.APosStoreCreditIssueInputSchema = exports.APosStoreCreditEntrySchema = exports.APosStoreCreditSourceSchema = exports.APosStoreCreditAccountSchema = exports.APosStoreCreditSourceKindSchema = exports.APosStoreCreditEntryTypeSchema = exports.APosStoreCreditOwnerTypeSchema = void 0;
const zod_1 = require("zod");
exports.APosStoreCreditOwnerTypeSchema = zod_1.z.enum(['customer', 'gift_card']);
exports.APosStoreCreditEntryTypeSchema = zod_1.z.enum(['issue', 'redeem', 'adjust', 'reverse', 'hold', 'capture', 'release', 'expire']);
exports.APosStoreCreditSourceKindSchema = zod_1.z.enum(['gaming_voucher', 'manual', 'refund', 'online_order', 'gift_card_sale']);
exports.APosStoreCreditAccountSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    accountId: zod_1.z.string(), // sca_{uuid}
    ownerType: exports.APosStoreCreditOwnerTypeSchema,
    customerId: zod_1.z.string().optional(),
    cardLast4: zod_1.z.string().optional(),
    balanceCents: zod_1.z.number().int().min(0),
    status: zod_1.z.enum(['active', 'frozen', 'closed']),
    currency: zod_1.z.literal('USD'),
    createdAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
exports.APosStoreCreditSourceSchema = zod_1.z.object({
    kind: exports.APosStoreCreditSourceKindSchema,
    ref: zod_1.z.string().optional(),
    locationId: zod_1.z.string().optional(),
    registerId: zod_1.z.string().optional(),
    machineId: zod_1.z.string().optional(),
    voucherNumber: zod_1.z.string().optional(),
});
exports.APosStoreCreditEntrySchema = zod_1.z.object({
    accountKey: zod_1.z.string(), // `${tenantId}#${accountId}`
    sk: zod_1.z.string(), // `${createdAt}#${entryId}` (createdAt zero-padded to 13 digits)
    entryId: zod_1.z.string(), // scl_{uuid}
    tenantId: zod_1.z.string(),
    accountId: zod_1.z.string(),
    type: exports.APosStoreCreditEntryTypeSchema,
    amountCents: zod_1.z.number().int(), // signed
    balanceAfterCents: zod_1.z.number().int().min(0),
    source: exports.APosStoreCreditSourceSchema,
    idempotencyKey: zod_1.z.string().min(1).max(200),
    reversesEntryId: zod_1.z.string().optional(),
    reason: zod_1.z.string().max(500).optional(),
    employeeId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.number(),
});
exports.APosStoreCreditIssueInputSchema = zod_1.z.object({
    customerId: zod_1.z.string().min(1),
    amountCents: zod_1.z.number().int().min(1).max(1000000),
    idempotencyKey: zod_1.z.string().min(1).max(200),
    source: exports.APosStoreCreditSourceSchema,
});
exports.APosStoreCreditAdjustInputSchema = zod_1.z.object({
    amountCents: zod_1.z.number().int().refine((n) => n !== 0, 'amountCents must be non-zero'),
    reason: zod_1.z.string().min(3).max(500),
    idempotencyKey: zod_1.z.string().min(1).max(200),
});
exports.APosStoreCreditRedeemInputSchema = zod_1.z.object({
    accountId: zod_1.z.string().min(1),
    amountCents: zod_1.z.number().int().min(1),
    idempotencyKey: zod_1.z.string().min(1).max(200),
    source: exports.APosStoreCreditSourceSchema,
});
//# sourceMappingURL=store-credit.schema.js.map